import * as APIRoutes from '@mm/api-routes';
import { snake } from '../helpers/converterString';
import { CompanyLevelFeatureFlag } from '../model/CompanyModel';
import AuthenticatedController from './AuthenticatedController';

export type SubscriptionFeatureFlag =
  | 'adsNewCtmAdsAutomaticSyncDisable'
  | 'adsNewCtmAdsManualSync'
  | 'adsOneNewCtmAd'
  | 'adsSetupDripCampain'
  | 'adsOneSponsoredAd'
  | 'adsSponsored'
  | 'adsUnlimitedNewCtmAds'
  | 'analyticsAds'
  | 'analytics'
  | 'analyticsBotContactsByPlatform'
  | 'analyticsBotContactsBySource'
  | 'analyticsBotFilterByDate'
  | 'analyticsBotKeywordsExport'
  | 'analyticsBotKeywordsTriggered'
  | 'analyticsBotViewAllDialogues'
  | 'analyticsBotViewUnansweredQuestions'
  | 'apiKey'
  | 'audiencesExportContacts'
  | 'audiencesCreateCustom'
  | 'audiencesSyncContacts'
  | 'automationDripCampaignsAcceptableTimebuilder'
  | 'automationRulesFollowUps'
  | 'automationRulesBusinessHours'
  | 'awaySetting'
  | 'botBuilderBotCloning'
  | 'botBuilderCreateFromTemplate'
  | 'botBuilderConditionalLogic'
  | 'botBuilderUnlimitedBots'
  | 'campaignsAudiencesSelection'
  | 'campaignsBlasterSend'
  | 'campaignsDripsSend'
  | 'campaignsScheduleSends'
  | 'commentGuardsEditFbPost'
  | 'connectionWidget'
  | 'connectPageUnlimitedPages'
  | 'customerChatAdvancedSettings'
  | 'customerChatEditConditions'
  | 'customerChatEditGreetingBehaviour'
  | 'customerChatGreetingEditor'
  | 'customerChatEditorRemoveMMBranding'
  | 'dripCampaigns'
  | 'delayWidget'
  | 'detailedDripStats'
  | 'desktopNotifications'
  | 'chatBlasters'
  | 'jsonWebhook'
  | 'leadsAssignment'
  | 'mobileMonkeyApi'
  | 'nativeIntegrations'
  | 'notificationWidget'
  | 'qqFollowUps'
  | 'settingsCompanyLogoUpload'
  | 'smsActivateNumber'
  | 'templatesCreate'
  | 'userInvites'
  | 'userInvitesEditorAndAdmin'
  | 'userEdit'
  | 'zapier'
  | 'xray'
  | 'xrayAdvancedCaptureSettings'
  | 'voyagerEnrichment'
  | 'fbRestore'
  | 'contactSuppression';

export type UpgradePlan = 'pro' | 'unicorn' | 'team2020';

export type RequiredPlan = 'pro' | 'unicorn' | 'team' | undefined;

export type FeaturesForPlans = {
  [k in SubscriptionFeatureFlag | CompanyLevelFeatureFlag]: UpgradePlan[];
};

export default class FeatureFlagsController extends AuthenticatedController {
  static getSubscriptionFeatures(
    facebookPageId: number,
  ): Promise<{ availableFeatures: SubscriptionFeatureFlag[] }> {
    return super.get(APIRoutes.FB_PAGE_FEATURES, snake({ facebookPageId }));
  }

  static getFeaturesForPlans(
    facebookPageId: number,
  ): Promise<{ upgradeList: FeaturesForPlans }> {
    return super.get(APIRoutes.FEATURES_FOR_PLANS, snake({ facebookPageId }));
  }
}
